import { ReactNode } from 'react';

type MainContentProps = {
  children: ReactNode;
};

const MainContent = ({ children }: MainContentProps) => {
  return (
    <main className="py-1">
      <div className="px-1">
        {children}
      </div>
    </main>
  );
};

export default MainContent;